import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || props.name;
  return <div className="w-full" data-id="element-65">
      {label && <label htmlFor={textareaId} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-66">
          {label}
        </label>}
      <textarea id={textareaId} className={`
          flex min-h-[80px] w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 
          focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-red-500 focus:ring-red-500' : ''}
          ${className}
        `} {...props} data-id="element-67" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-68">{error}</p>}
    </div>;
}